export default __webpack_public_path__ + "static/media/37.9f3bbe52.jpg";